// FormFieldTypes/DatePickerWrapper.tsx
import React from 'react';
import { TextField } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

const DatePickerWrapper = ({ field, value, onChange, error }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={field.label}
        value={value || null}
        onChange={(newValue) => onChange(field.name, newValue)}
        format="DD.MM.YYYY"
        slotProps={{
          textField: {
            fullWidth: true,
            error: Boolean(error),
            helperText: error ? <span style={{ color: "red" }}>{error}</span> : "",
            sx: { marginBottom: "15px" },
          },
        }}
        minDate={field.minDate} // ako želiš da proslediš minDate kroz field definiciju
         maxDate={field.maxDate}
        renderInput={(params) => <TextField {...params} />}
      />
    </LocalizationProvider>
  );
};

export default DatePickerWrapper;
